
import { configureStore } from '@reduxjs/toolkit';
import fotogritReducer from './reducers/fotogritReducer';
import settingReducer from './reducers/settingReducer';
import playersReducer, { submitPlayersAndMatchData } from './reducers/playersReducer'; // Updated playersReducer with RTK
import eventsReducer from './reducers/eventsReducer'; // Updated playersReducer with RTK
import undoable, { excludeAction } from 'redux-undo';
import logReducer from './reducers/logReducer';
import notificationReducer from './reducers/notificationReducer';
import homeReducer from './reducers/homeReducer';
import dropdownReducer from './reducers/dropdownSlice';
// Root reducer setup
const rootReducer = {
  fotogritReducer,
  settingReducer,
  logReducer,
  notificationReducer,
  eventsReducer,
  playersReducer,
  home: homeReducer, // Add the home reducer
  dropdown: dropdownReducer, // Add the dropdown reducer
  // playersReducer: undoable(playersReducer, {
  //   limit: 20,
  //   // filter: excludeAction(SUBMIT_PLAYERS_AND_MATCH_DATA),
  //   filter: excludeAction(),
  // }),
};

// Configure the store
const store = configureStore({
  reducer: rootReducer,
});

export default store;
